import { render, staticRenderFns } from "./TiempoPorZonaItem.vue?vue&type=template&id=0af77e43"
import script from "./TiempoPorZonaItem.vue?vue&type=script&lang=js"
export * from "./TiempoPorZonaItem.vue?vue&type=script&lang=js"
import style0 from "./TiempoPorZonaItem.vue?vue&type=style&index=0&id=0af77e43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports